import { Component, Output, ViewChild, EventEmitter, Input } from '@angular/core';
import { NavController, NavParams, LoadingController, Events, PopoverController, Platform, ModalController} from 'ionic-angular';
import { AppState } from '../../config/state';
import { LocationsProvider } from '../../providers/locations/locations';
import { EventsProvider } from '../../providers/events/events';
import { ToastAlertsProvider } from '../../providers/toast-alerts/toast-alerts';
import moment from 'moment';
import { VirtualScrollerComponent } from 'ngx-virtual-scroller';
import { CoSelfcheckAccountPage } from '../../pages/co-selfcheck-account/co-selfcheck-account';
import { CoCalendarComponent } from '../co-calendar/co-calendar';
import { CoPickerComponent } from '../co-picker/co-picker.component';

/**
 * Generated class for the CoEventCategoryFilteringComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'co-event-category-filtering',
  templateUrl: 'co-event-category-filtering.html'
})
export class CoEventCategoryFilteringComponent {
  public wideScreen:boolean;
  private finderStage = 'choose';
  private nextDayText = '';
  private listMessage = '';
  private eventDate = 0;
  private selectedBranchId;
  private branchList = [];
  private ageGrpups = [];
  private eventTypes = [];
  private timeRanges = [];
  private dataRanges = [];
  private currentDensity = 0;
  private email:string = '';
  private searchType: string = 'filter';
  private eventTimeStartToggle: number = -1;
  public searchScreen: string = 'filter';
  private eventSearchName: string;
  private totalEvents: number = 0;
  private displayDate: {lower: string, upper: string} = {lower: "", upper: ""};
  private displayTime: any;
  private rangeBarTime: { lower: number, upper: number } = { lower: 0, upper: 96 };
  // private emailRegex: any;
  @Input('buttonText') buttonText:string;
  @Input('screen') screenType:string;
  @Input('currentFilters') currentFilters:any;
  @Input('pickFilter') pickFilter:boolean =false;
  @ViewChild(VirtualScrollerComponent)
  private virtualScroller: VirtualScrollerComponent;
  @Output() outputChosenFilters: EventEmitter<any> = new EventEmitter<any>();
  constructor(public navCtrl: NavController, private platform:Platform, public navParams: NavParams, private state: AppState, private location: LocationsProvider, private eventsProvider: EventsProvider, private loadingCtrl: LoadingController, private toast: ToastAlertsProvider, private events : Events, private popoverCtrl : PopoverController, private modalCtrl: ModalController) {
    this.nextDayText = moment().add(2, 'day').startOf('day').format("dddd");
    this.wideScreen = this.platform.width() > 992;
    this.selectedBranchId = this.state.locationId || 0;
    this.location.getLocations().then(locations => {
      // console.log(locations)
      this.branchList = locations;
      this.branchList.map(l =>  {
        l.selected = false
      });
      this.branchList.sort(this.sortByName);
    });
    this.eventsProvider.getEventTypes().then(types => {
      this.eventTypes = JSON.parse(JSON.stringify(types));
      this.eventTypes.map(t => t.selected = false);
      this.eventTypes.sort(this.sortByName);
      this.state.eventColors = {
        types:this.eventTypes
      };
    });
    this.eventsProvider.getAgeGroups().then(ages => {
      this.ageGrpups = JSON.parse(JSON.stringify(ages));
      this.ageGrpups.map(a => {
        a.selected = false;
        a.name = a.namePlural;
      });
      this.ageGrpups.sort(this.sortByName);
    });
    if (this.state.patron) {
      this.email = this.state.patron.email;
    }
    this.timeRanges = [
      {name:"8am-10am", lower: { hour: 8, minute: 0 }, upper: { hour: 10, minute: 0 }},
      {name:"10am-12pm", lower: { hour: 10, minute: 0 }, upper: { hour: 12, minute: 0 }},
      {name:"12pm-2pm", lower: { hour: 12, minute: 0 }, upper: { hour: 14, minute: 0 }},
      {name:"2pm-4pm", lower: { hour: 14, minute: 0 }, upper: { hour: 16, minute: 0 }},
      {name:"4pm-6pm", lower: { hour: 16, minute: 0 }, upper: { hour: 18, minute: 0 }},
      {name:"6pm-8pm", lower: { hour: 18, minute: 0 }, upper: { hour: 20, minute: 0 }},
      {name:"8pm-10pm", lower: { hour: 20, minute: 0 }, upper: { hour: 22, minute: 0 }},
    ];
    this.timeRanges.map(t => t.selected = false);

    this.dataRanges = [
      { name: "Set custom date range", selected: false, singleSelect: true,  value: 7  },
      { name: "Today", selected: false, singleSelect: true, value: 0 },
      { name: "Tomorrow", selected: false, singleSelect: true,  value: 1 },
      { name: "This week", selected: false, singleSelect: true,  value: 3  },
      { name: "Next week", selected: false, singleSelect: true,  value: 4  },
      { name: "This month", selected: false, singleSelect: true,  value: 5  },
      { name: "Next month", selected: false, singleSelect: true,  value: 6  }
    ]

    this.changeEventDate(0);
  }
  sortByName(a,b) {
    const nameA = a.name.toUpperCase();
    const nameB = b.name.toUpperCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  }
  ngOnInit(): void {
    //Called after the constructor, initializing input properties, and the first call to ngOnChanges.
    //Add 'implements OnInit' to the class.
    if (this.pickFilter) this.searchScreen = 'name';
  }
  ngAfterViewInit(): void {
    setTimeout(()=>this.setCurrentFilters(), 0);
  }
  selectType(input){
    input.selected = !input.selected;
    this.getEventCount();
  }
  getDisplayTime(){
	  const start = moment(this.displayTime.lower).format("h:mma");
	  const end = moment(this.displayTime.upper).format("h:mma");
	  if(start==='12:00am' && end==='12:00am'){
		  return "All day";
	  }
	  return `${start} - ${end}`;
	  //{{displayTime.lower | momentDate:"h:mma"}} - {{displayTime.upper | momentDate:"h:mma"}}
  }
  openDatePicker(){
    let popover = this.popoverCtrl.create(CoCalendarComponent, { popup: true, range: true }, { cssClass: 'date-time-popover' });
    popover.present();

    popover.onDidDismiss(data => {
      if(data && data.from){
        this.displayDate.lower = data.from.startOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.displayDate.upper = data.to.endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.eventDate = 7;
        this.getEventCount();
      }
    });
  }

  openPicker(type, title) {
    let pickerModal = this.modalCtrl.create(CoPickerComponent, { title: title, items: this.getListForType(type), valueChanged:(data) => {
        this.updateListForType(type, data);
        if (type == 'date') {
          pickerModal.dismiss();
          const selectedItem = data.find((x) => x.selected == true);
          if (selectedItem.value == 7) {
            this.openDatePicker();
          }
        }
    }});
    pickerModal.present();
    pickerModal.onDidDismiss(() => {
      switch(type) {
        case 'time':
          this.timeRanges.shift();
        break;
        case 'type':
          this.eventTypes.shift();
        break;
        case 'age':
          this.ageGrpups.shift();
        break;
        case 'branch':
          this.branchList.shift();
        break;
      }
      this.getEventCount();
    });
  }
  getListForType(type: String) {
    switch(type) {
      case 'date':
        return this.dataRanges;
      break;
      case 'time':
        this.timeRanges.unshift({
          name: "All day", singleSelect: true, selected: !this.checkIfSelected(type)
        })
        return this.timeRanges;
      break;
      case 'type':
        this.eventTypes.unshift({
          name: "All", singleSelect: true, selected: !this.checkIfSelected(type)
        })
        return this.eventTypes;
      break;
      case 'age':
        this.ageGrpups.unshift({
          name: "All", singleSelect: true, selected: !this.checkIfSelected(type)
        })
        return this.ageGrpups;
      break;
      case 'branch':
        this.branchList.unshift({
          name: "All", singleSelect: true, selected: !this.checkIfSelected(type)
        })
        return this.branchList;
      break;
    }
  }
  updateListForType(type: String, data:Array<any>) {
    switch(type) {
      case 'date':
        const selectedItem = data.find((x) => x.selected == true);
        if (selectedItem) {
          this.changeEventDate(selectedItem.value);
        } else {
          this.changeEventDate(0);
        }
        this.dataRanges = data;
      break;
      case 'time':
        this.timeRanges = data;
      break;
      case 'type':
        this.eventTypes = data;
      break;
      case 'age':
        this.ageGrpups = data;
      break;
      case 'branch':
        this.branchList = data;
      break;
    }
  }
  getStringForSelected(type) {
    let selectedString = "";
    switch(type) {
      case 'time':
        this.timeRanges.forEach((x) => {
          if (x.selected) {
            selectedString += (selectedString.length > 0 ? ", ":"") + x.name;
          }
        })
        if (selectedString.length == 0) return "All day";
        return selectedString;
      break;
      case 'type':
        this.eventTypes.forEach((x) => {
          if (x.selected) {
            selectedString += (selectedString.length > 0 ? ", ":"") + x.name;
          }
        })
        if (selectedString.length == 0) return "All";
        return selectedString;      break;
      case 'age':
        this.ageGrpups.forEach((x) => {
          if (x.selected) {
            selectedString += (selectedString.length > 0 ? ", ":"") + x.name;
          }
        })
        if (selectedString.length == 0) return "All";
        return selectedString;      break;
      case 'branch':
        this.branchList.forEach((x) => {
          if (x.selected) {
            selectedString += (selectedString.length > 0 ? ", ":"") + x.name;
          }
        })
        if (selectedString.length == 0) return "All";
        return selectedString;      break;
    }
  }

  resetFilter(section){
    switch (section){
      case 'date':
        this.changeEventDate(0);
      break;
      case 'time':
        this.timeRanges.map(t => t.selected = false);
      break;
      case 'type':
        this.eventTypes.map(t => t.selected = false);
      break;
      case 'age':
        this.ageGrpups.map(a => a.selected = false);
      break;
      case 'branch':
        this.branchList.map(l => l.selected = false);
      break;
      case 'all':
        this.changeEventDate(0);
        this.timeRanges.map(t => t.selected = false);
        this.eventTypes.map(t => t.selected = false);
        this.ageGrpups.map(a => a.selected = false);
        this.branchList.map(l => l.selected = false);
      break;
    }
    this.getEventCount();
  }
  checkIfSelected(section){
    switch (section){
      case 'time':
        return this.timeRanges.filter(t => t.selected).length > 0;
      case 'type':
        return this.eventTypes.filter(t => t.selected).length > 0;
      case 'age':
        return this.ageGrpups.filter(a => a.selected).length > 0;
      case 'branch':
        return this.branchList.filter(l => l.selected).length > 0;
    }
  }
  changeEventDate(num){
    this.eventDate = num;
    this.getEventCount();
  }
  getDateEndpoints(){
    let start, end;
    switch (this.eventDate) {
      case 0:
        start = moment().startOf('day').format("YYYY-MM-DD HH:mm:ss");
        end = moment().endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.displayDate.lower = start;
        this.displayDate.upper = end;
        break;
      case 1:
      case 2:
        start = moment().add(this.eventDate, 'day').startOf('day').format("YYYY-MM-DD HH:mm:ss");
        end = moment().add(this.eventDate, 'day').endOf('day').format("YYYY-MM-DD HH:mm:ss");
        this.displayDate.lower = start;
        this.displayDate.upper = end;
        break;
      case 3:
        start = moment().startOf('day').format("YYYY-MM-DD HH:mm:ss");
        end = moment().endOf('week').format("YYYY-MM-DD HH:mm:ss");
        this.displayDate.lower = start;
        this.displayDate.upper = end;
        break;
      case 4:
        start = moment().add(1, 'week').startOf('week').format("YYYY-MM-DD HH:mm:ss");
        end = moment().add(1, 'week').endOf('week').format("YYYY-MM-DD HH:mm:ss");
        this.displayDate.lower = start;
        this.displayDate.upper = end;
        break;
      case 5:
        start = moment().startOf('day').format("YYYY-MM-DD HH:mm:ss");
        end = moment().endOf('month').format("YYYY-MM-DD HH:mm:ss");
        this.displayDate.lower = start;
        this.displayDate.upper = end;
        break;
      case 6:
        start = moment().add(1, 'month').startOf('month').format("YYYY-MM-DD HH:mm:ss");
        end = moment().add(1, 'month').endOf('month').format("YYYY-MM-DD HH:mm:ss");
        this.displayDate.lower = start;
        this.displayDate.upper = end;
        break;
      case 7:
        start = this.displayDate.lower;
        end = this.displayDate.upper;
        break;
    }
    return {start: start, end: end};
  }
  setCurrentFilters(){
    if (!this.currentFilters) {
      this.resetFilter('all');
      return
    }
    // console.log(this.currentFilters);
    if (this.currentFilters.nameSearch && this.currentFilters.nameSearch.length > 0) {
      this.eventSearchName = this.currentFilters.nameSearch;
    }
    this.currentFilters['ages'].forEach(age => {
      let on = this.ageGrpups.find(a => a.namePlural == age);
      if (on) on.selected = true;
    });
    this.currentFilters['types'].forEach(type => {
      let on = this.eventTypes.find(a => a.name == type);
      if (on) on.selected = true;
    });
    this.currentFilters['locations'].forEach(loc => {
      let on = this.branchList.find(a => a.id == loc);
      if (on) on.selected = true;
    });
    this.currentFilters['timeRanges'].forEach(tr => {
      let on = this.timeRanges.find(a => a.name == tr.name)
      if (on) on.selected = true;
    });
    if (this.currentFilters['dateID'] === 7){
      this.displayDate.lower = this.currentFilters.start;
      this.displayDate.upper = this.currentFilters.end;
    }
    this.changeEventDate(this.currentFilters['dateID']);
    this.getEventCount();
  }

  findEvents(nameSearch?) {
    const ages = this.ageGrpups.filter(a => a.selected).map(a => a.namePlural);
    const types = this.eventTypes.filter(t => t.selected).map(a => a.name);
    const locations = this.branchList.filter(l => l.selected).map(a => a.id);
    let branch;
    let daterange = this.getDateEndpoints();
    if (this.selectedBranchId == -1) {
      branch = []
    } else {
      branch = this.selectedBranchId;
    }
    let filters = {
      dateID: this.eventDate,
      ages: ages || null,
      types: types || null,
      start: daterange.start || null,
      end: daterange.end || null,
      locations: locations || null,
      selectedLocation: branch,
      timeRanges: this.timeRanges.filter(r => r.selected),
      email: this.email,
      nameSearch: nameSearch? this.eventSearchName.toLowerCase() : false,
      eventCount: this.totalEvents,
      branchList: this.branchList
    }
    // console.log(filters);
    this.outputChosenFilters.emit(filters);
  }

  myAccount() {
    this.state.nav.push(CoSelfcheckAccountPage);
  }
  getEventCount(){
    const ages = this.ageGrpups.filter(a => a.selected).map(a => a.namePlural);
    const types = this.eventTypes.filter(t => t.selected).map(a => a.name);
    const locations = this.branchList.filter(l => l.selected).map(a => a.id);
    let daterange = this.getDateEndpoints();
    let countdata = {
      format: 'pdf',
      end_date: daterange.end,
      start_date: daterange.start,
      email: '',
      ages: ages.length > 0? ages : ["all"],
      types: types.length > 0? types : ["all"],
      location: locations.length > 0? locations : ["all"],
      type: 1
    };
    let brochure = {countdata: countdata};
    if (brochure) {
      let self = this;
      let url = '';
      // brochure['clientId'] = 157; //DEV SERVER CLIENT SEASONS
      brochure['clientId'] = this.state.client.id; //WHEN LIVE
    //   url = `https://api-colin.communico.co/v2/brochure/methods/getEventCount`; //SINCE ON DEV
      url = `https://api.communico.co/v2/brochure/methods/getEventCount`; // WHEN LIVE
      fetch(url, {
        method: 'post',
        body: JSON.stringify(brochure),
        headers: {'Content-Type': 'application/json'}
      }).then(res => res.json()).then(result =>{
        this.totalEvents = result.count;
      }).catch(err => {});
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/co-event-category-filtering/co-event-category-filtering.ts